import { useEffect, useState } from "react";
import OrderCard from "../../../../components/common/orderCard";
import DeleteMemberModal from "../../../../components/common/modalMember";
import { Card, Rate, message } from "antd";
import TextArea from "../../../../components/common/textArea";
import Button from "../../../../components/common/button";
import { colors } from "../../../../share/constants/enums";
import { getOrderDetails, updateOrder } from "../../../../api/order";
import { addReview } from "../../../../api/reviews";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const OrderDetails = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const [render, setRender] = useState(false);
  const [comment, setComment] = useState("");
  const [data, setData] = useState();
  const [stars, setStars] = useState(0);
  const [selectedCard, setSelectedCard] = useState();
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  const parts = location.pathname.split("/");
  const id = parts[parts.length - 1];

  const user = useSelector((state) => state?.user?.response);
  const text = useSelector((state) => state?.text?.value);
  const fetchData = async () => {
    const res = await getOrderDetails(id);
    if (res) {
      setData(res);
    }
  };
  useEffect(() => {
    fetchData();
  }, [render]);

  const handleRatingChange = (value) => {
    setStars(value);
  };

  const reviewHandler = async () => {
    setLoader(true);
    const payload = {
      customerUserId: selectedCard?.userId?._id,
      businessId: selectedCard?.businessId?._id,
      orderId: selectedCard?._id,
      isBusiness: true,
      rating: stars,
      comments: [
        {
          commentUser: user?._id,
          commentText: comment,
        },
      ],
    };
    const res = await addReview(payload);
    const updatePayload = {
      orderStatus: "COMPLETED",
    };

    if (res) {
      await updateOrder(selectedCard?._id, updatePayload);
      message.success("Review Sent!");
      setComment("");
      setStars(0);
      setRender(!render);
    }
    setLoader(false);
  };
  const hideModal = () => {
    setIsModalOpen(false);
    setShowCard(false);
    setComment("");
    setStars(0);
  };
  const YesClickHandler = () => {
    setIsModalOpen(false);
    setShowCard(true);
    setComment("");
    setStars(0);
  };
  const showModal = (data) => {
    setIsModalOpen(true);
    setSelectedCard(data);
  };
  const handleTextChange = (e) => {
    setComment(e);
  };

  const showCardForOrder = (data) => {
    return (
      <Card className="bg-inputFieldGrey h-24 mx-3 mb-2">
        <div className="bg-white m-3">
          <TextArea
            className="h-10 max-h-10 "
            placeholder="Please leave a Review regarding this Order!"
            text={comment}
            handleTextChange={handleTextChange}
          />
        </div>
        <div className="flex justify-between">
          <div className="ml-3">
            <Rate
              className="text-[18px]"
              value={stars}
              allowHalf
              style={{
                color: colors.secondaryOrange,
              }}
              onChange={handleRatingChange}
            />
          </div>
          <Button
            className="w-15 !h-4 !rounded-md mr-3 !mb-1"
            color={colors.secondaryOrange}
            title="Post Review"
            loading={loader}
            onClick={reviewHandler}
          />
        </div>
      </Card>
    );
  };
  return (
    <div className={`relative ${isModalOpen ? "blur-sm " : ""}`}>
      <div className="">
        <div className="grid  md:grid-cols-2 2xl:grid-cols-3  gap-2 ">
          <div>
            <OrderCard data={data} openModal={() => showModal(data)} />
            {showCard &&
              selectedCard?._id === data?._id &&
              showCardForOrder(data)}
          </div>
        </div>
      </div>
      {isModalOpen && (
        <DeleteMemberModal
          title="Redeemed"
          text="Do You Want to List this Order as Redeemed?"
          onCancel={hideModal}
          onOk={YesClickHandler}
        />
      )}
    </div>
  );
};
export default OrderDetails;
